export default __webpack_public_path__ + "static/media/road-g24480aaaa_1920.e49c86e1.jpg";